import { render, staticRenderFns } from "./NewsCenterDetails6.vue?vue&type=template&id=264dae54&scoped=true"
import script from "./NewsCenterDetails6.vue?vue&type=script&lang=js"
export * from "./NewsCenterDetails6.vue?vue&type=script&lang=js"
import style0 from "./NewsCenterDetails6.vue?vue&type=style&index=0&id=264dae54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264dae54",
  null
  
)

export default component.exports